import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Color} from 'ng2-charts/ng2-charts';
import { faTh, faCheck, faTrash, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { PackageService } from "../../../../app/package/package.service";
import { UsersService } from '../../../../app/users/users.service';
import { RequestsService } from '../../../services/requests.service';
import { VehicleService } from "../../../vehicle/vehicle.service";


@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.sass']
})
export class AnalyticsComponent implements OnInit {

  faTh = faTh;
  faCheck = faCheck;
  faTrash = faTrash;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;

  heading = 'Analytics Dashboard';
  // subheading = 'This is an example dashboard created using build-in elements and components.';
  icon = 'pe-7s-plane icon-gradient bg-tempting-azure';

  slideConfig6 = {
    className: 'center',
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    adaptiveHeight: true,
    dots: true,
  };

  public datasets = [
    {
      label: 'My First dataset',
      data: [65, 59, 80, 81, 46, 55, 38, 59, 80],
      datalabels: {
        display: false,
      },

    }
  ];

  public datasets2 = [
    {
      label: 'My First dataset',
      data: [46, 55, 59, 80, 81, 38, 65, 59, 80],
      datalabels: {
        display: false,
      },

    }
  ];

  public datasets3 = [
    {
      label: 'My First dataset',
      data: [65, 59, 80, 81, 55, 38, 59, 80, 46],
      datalabels: {
        display: false,
      },

    }
  ];
  public lineChartColors: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(247, 185, 36, 0.2)',
      borderColor: '#f7b924',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#f7b924',
      pointBackgroundColor: '#fff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#f7b924',
    },
  ];

  public lineChartColors2: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(48, 177, 255, 0.2)',
      borderColor: '#30b1ff',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#30b1ff',
      pointBackgroundColor: '#ffffff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#ffffff',
      pointHoverBorderColor: '#30b1ff',
    },
  ];

  public lineChartColors3: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(86, 196, 121, 0.2)',
      borderColor: '#56c479',
      borderCapStyle: 'round',
      borderDash: [],
      borderWidth: 4,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
      pointBorderColor: '#56c479',
      pointBackgroundColor: '#fff',
      pointHoverBorderWidth: 4,
      pointRadius: 6,
      pointBorderWidth: 5,
      pointHoverRadius: 8,
      pointHitRadius: 10,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#56c479',
    },
  ];

  public labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August'];

  public options = {
    layout: {
      padding: {
        left: 0,
        right: 8,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          display: false,
          beginAtZero: true
        },
        gridLines: {
          display: false
        }
      }],
      xAxes: [{
        ticks: {
          display: false
        },
        gridLines: {
          display: false
        }
      }]
    },
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false
  };


  constructor(
    private packageService: PackageService,
    private userService:UsersService,
    private driverPartnerService :RequestsService,
    private router: Router,
    private vehicleService: VehicleService,
  ) {
  }

  today:any;
  istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  ngOnInit() { 
    // this.istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    this.today = new Date(new Date().getTime() + this.istOffset); // Adjust to IST
    // console.log("today", this.today)
    this.today.setHours(0, 0, 0, 0); // Set to start of the day in IST

    
    this.getAllPackage()
    this.getAllUsers()
    this.ApprovedDrivers()
    this.pendingDrivers()
    this.getAllVehicle()
    this.packersMoversRequests()
  }
    // Common function to filter users created today
filterTodaysUsers(users:[], timestampKey:string){
  let todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0); // Set todayDate to midnight
  return users.filter((item: any) => {
      let userDate = new Date(item[timestampKey] * 1000); // Convert timestamp to date
      userDate.setHours(0, 0, 0, 0); // Set to midnight for comparison
      return userDate.getTime() === todayDate.getTime();
  });
}

  // Get All Packages
  todaysPackages:any[]=[]
  todaysPackagesCount:Number
  totalPackages:Number
  getAllPackage() {
    let data = {
      perPage: 50,
      page: 0,
      isDeleted: 0,
    };
    this.packageService.getAllPackage(data).subscribe((result: any) => {
      let allPackagesList = result.data;
      this.totalPackages = result.totalRecords;
      this.todaysPackages = this.filterTodaysUsers(allPackagesList, "timestamp")
      this.todaysPackagesCount = this.todaysPackages.length;
      // console.log("Today's packages (IST):", this.todaysPackages);
      // console.log("Today's packages count (IST):", this.todaysPackagesCount);
    });
  }
  routeViewDetails(data) {
    this.router.navigate(["dashboard/viewPackageDetails"], {
      queryParams: { id: data._id },
    });
  }
  routeViewVehicleDetails(data) {
    this.router.navigate(["dashboard/viewVehicleDetails"], {
      queryParams: { id: data._id },
    });
  }

  // Get All Users
  todaysUsers:any[]=[]
  todaysUsersCount:Number;
  totalUsers:Number;
  getAllUsers(){ 
    let data = { 
      "perPage" :  50,
      "page"    : 0,
      "isDeleted": 0
    }
    // console.log(data)
    this.userService.getUsers(data).subscribe((result:any)=>{    
      if(result.statusCode == 200){
        this.totalUsers=result.totalRecords
        let allUsers = result.data
        this.todaysUsers = this.filterTodaysUsers(allUsers, "createdOnTS")
        this.todaysUsersCount = this.todaysUsers.length;
        // console.log("Today's Registred Users (IST):", this.todaysUsers);
        // console.log("Today's Registred Users count (IST):", this.todaysUsersCount);
      }else{console.log("Error in Get Users Api")
      }
    })
  }
  // Approved Drivers
  totalApprovedDriversCount:Number;
  todaysOnboardedDrivers:any[]=[]
  todaysOnbordedDriversCount:Number;
  ApprovedDrivers(){     
    let data = { 
      "perPage" : 100,
      "page"    : 0,
      "isDeleted": 0,
      "verificationStatus" : 2
    }
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result:any)=>{
      // console.log('all data  ',result);
      if(result.statusCode == 200){
        let onBordedDrivers = result.data
        // console.log("Approved All Drivers",onBordedDrivers)
        this.totalApprovedDriversCount = result.totalRecords;
        this.todaysOnboardedDrivers = this.filterTodaysUsers(onBordedDrivers, "updatedOnTS")
        // console.log("Approved Drivers", this.todaysOnboardedDrivers)
        this.todaysOnbordedDriversCount=this.todaysOnboardedDrivers.length

      }else{
        console.log("Error in Approved Drivers Api")
      }
    })
  }

  totalRegistredDrivers:Number
  todaysRegDrivers:any[]=[]
  registredDrivers() {     
    let data = { 
      "perPage": 50,
      "page": 0,
      "isDeleted": 0,
      "verificationStatus": 0
    };
  
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        let registredDrivers = result.data;  
        let todaysRegistredDrivers = this.filterTodaysUsers(registredDrivers, "createdOnTS")
        this.totalRegistredDrivers = todaysRegistredDrivers.length;
        this.todaysRegDrivers=todaysRegistredDrivers
        // console.log("Today's Registered Drivers (IST):", todaysRegistredDrivers);
        // console.log("Today's Registered Drivers count (IST):", this.totalRegistredDrivers);
      } else {
        console.log("Error in Approved Drivers API");
      }
    });
  }
  totalTodaysRegDrivers:any[]
  totalPendingDrivers:any;
  totalPendingDriversCount:Number
  pendingDrivers() {  
    this.registredDrivers()   
    let data = { 
      "perPage": 50,
      "page": 0,
      "isDeleted": 0,
      "verificationStatus": 1
    };
    this.driverPartnerService.getDriverPartnerRequests(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        let pendingDrivers = result.data;
        let todaysDrivers:any[] = this.filterTodaysUsers(pendingDrivers,"createdOnTS")
        todaysDrivers.push(...this.todaysRegDrivers)
        this.totalTodaysRegDrivers= todaysDrivers
        this.totalPendingDriversCount = this.totalTodaysRegDrivers.length;
        // console.log("Today's all Registered Drivers (IST):", this.totalTodaysRegDrivers);
        // console.log("Today's all Registered Drivers count (IST):", this.totalPendingDriversCount);
      } else {
        console.log("Error in Pending Drivers API");
      }
    });
  }

  allVehicleList:any;
  getAllVehicle() {
    let data = {
      perPage: 10,
      page: 0,
      isDeleted: 0,
    };
    this.vehicleService.getAllVehicle(data).subscribe((result: any) => {
      // console.log("get all vehicles ", result);
      this.allVehicleList = result.data.filter((vehicle:any) => vehicle.currentStatus !== 0)      // this.totalItems = result.totalRecords;
    });
  }
  
  packersMoversItemCount:Number
  packersMoversRequests(){
    let data = { 
      "perPage" : 5,
      "page"    : 0,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      //  "isDeleted": 2        // 2 for getting all users
    }
    this.driverPartnerService.getPackerMoverRequests(data).subscribe((result:any)=>{
      console.log('all data  ',result);
      if(result.statusCode == 200){
        // this.allPackerMoverList = result.data
        // this.allPackerMoverList_forFilter = result.data
        this.packersMoversItemCount = result.totalRecords;
      }else{
        console.log("Error in get Packer Mover Api")
      }
    })
  }
 

}
